import { handleAxiosAuthError } from '../utils/AxiosErrorHandling';
import apiClient from '../api/apiClient'; // ✅ استفاده از apiClient به جای axios

// ✅ حذف AUTH_URL و BASE_API_URL – مسیرها نسبت به baseURL در apiClient تعیین می‌شوند
// (فرض می‌کنیم apiClient.baseURL برابر با آدرس بک‌اند است)
// اما چون baseURL شامل '/api/v1' است، برای رسیدن به '/api/users' باید از '../users' استفاده کنیم

const setAuthData = ({ token, refresh_token, user_info, remember_me = false }) => {
    const storage = localStorage;
    if (token) {
        storage.setItem('access_token', token);
        if (refresh_token) storage.setItem('refresh_token', refresh_token);
    }
    if (user_info) {
        storage.setItem('user', JSON.stringify(user_info));
        storage.setItem('userId', user_info.id);
        if (user_info.phone_number) storage.setItem('phoneNumber', user_info.phone_number);
    }
};

const clearAuthData = () => {
    [localStorage, sessionStorage].forEach(storage => {
        ['access_token', 'refresh_token', 'user', 'userId', 'phoneNumber'].forEach(key => storage.removeItem(key));
    });
};

const getAuthTokens = () => {
    let token = localStorage.getItem('access_token');
    if (token) return token;
    return sessionStorage.getItem('access_token');
};

// --------------------------------------------------------------
// ✅ اصلاح تابع loginUser با مسیر '../users/login/'
// --------------------------------------------------------------
const loginUser = async (identifier, password, remember_me = false) => {
    try {
        // مسیر مطابق با urlpatterns بک‌اند: /api/users/login/
        const response = await apiClient.post('../users/login/', { identifier, password });
        const { access, refresh, user_info } = response.data;

        // ✅ اطلاعات کاربر را از user_info استخراج کنید
        const userInfo = {
            id: user_info.id,
            full_name: user_info.full_name || '',
            email: user_info.email || '',
            phone_number: user_info.phone_number || '',
            identifier: identifier, // همان چیزی که کاربر وارد کرده (برای نمایش)
        };

        setAuthData({
            token: access,
            refresh_token: refresh,
            user_info: userInfo,
            remember_me,
        });

        return userInfo;
    } catch (error) {
        throw handleAxiosAuthError(error, 'login');
    }
};

// --------------------------------------------------------------
// ✅ اصلاح registerUser با مسیر '../users/register/'
// --------------------------------------------------------------
const registerUser = async (phone_number, email, password, full_name = '') => {
    try {
        const payload = {
            password: password,
            full_name: full_name ? String(full_name).trim() : "",
            phone_number: phone_number && phone_number.trim() !== "" ? phone_number.trim() : null,
            email: email && email.trim() !== "" ? email.trim() : null
        };
        const response = await apiClient.post('../users/register/', payload);
        return response.data;
    } catch (error) {
        throw handleAxiosAuthError(error, 'register');
    }
};

// --------------------------------------------------------------
// ✅ اصلاح درخواست بازیابی رمز با مسیر '../users/password-reset/...'
// --------------------------------------------------------------
const requestPasswordReset = async (identifier) => {
    try {
        const response = await apiClient.post('../users/password-reset/request/', { identifier });
        return response.data;
    } catch (error) {
        throw handleAxiosAuthError(error, 'general');
    }
};

const confirmPasswordReset = async ({ identifier, otp_code, password }) => {
    try {
        const response = await apiClient.post('../users/password-reset/confirm/', {
            identifier, otp_code, password, password2: password,
        });
        return response.data;
    } catch (error) {
        throw handleAxiosAuthError(error, 'general');
    }
};

// --------------------------------------------------------------
// توابع خروج از سیستم و کمکی
// --------------------------------------------------------------
const logout = () => {
    clearAuthData();
    if (window.location.pathname !== '/login' && window.location.pathname !== '/register') {
        window.location.href = '/';
    }
};

const authService = {
    loginUser,
    registerUser,
    logout,
    requestPasswordReset,
    confirmPasswordReset,
    getAuthTokens,
    setAuthData,
    clearAuthData,
    getUserInfo: () => {
        const user = localStorage.getItem('user') || sessionStorage.getItem('user');
        return user ? JSON.parse(user) : null;
    },
    isAuthenticated: () => !!getAuthTokens(),
};

export default authService;